import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Course } from "@/types/course";
import { Send } from "lucide-react";
import { CourseHeader } from "./CourseHeader";
import { Student, StudentsTable } from "./StudentsTable";

interface EnrollmentProps {
  course: Course;
  students: Student[];
  onShare: () => void;
}

export const Enrollment = ({
  course,
  students,
  onShare,
}: EnrollmentProps) => {
  return (
    <div className="max-w-5xl mx-auto">
      <CourseHeader
        title="Enrollment"
        courseTitle={course.title}
        info={
          <div>
            <span className="text-muted-foreground">Students enrolled: </span>
            <Badge variant="secondary">{students.length}</Badge>
          </div>
        }
      />
      {students.length > 0 ? (
        <StudentsTable data={students} />
      ) : (
        <div className="flex flex-col items-center justify-center h-[400px] text-center space-y-6">
          <div className="space-y-2">
            <h3 className="text-xl font-medium">No students enrolled</h3>
            <p className="text-muted-foreground text-sm">
              Share your course with your students so they can enroll.
            </p>
          </div>
          <Button variant="secondary" onClick={onShare}>
            Share course
            <Send className="ml-2 h-4 w-4" />
          </Button>
        </div>
      )}
    </div>
  );
};

